const mixin = {
  computed: {
    isMobile() {
      return this.$isMobile();
    },
  },
};

export default mixin;
